module.exports = __webpack_public_path__ + "static/media/refresh.68c87e01.svg";